import { render } from "./School.vue?vue&type=template&id=b03e1734&scoped=true"
import script from "./School.vue?vue&type=script&lang=js"
export * from "./School.vue?vue&type=script&lang=js"

import "./School.vue?vue&type=style&index=0&id=b03e1734&lang=scss&scoped=true"
import "./School.vue?vue&type=style&index=1&id=b03e1734&lang=css"

import exportComponent from "D:\\pro\\edu-hsd\\cxcj\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b03e1734"]])

export default __exports__